import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AgentAvatar, PALETTES, parseSeed } from './AgentAvatar';

/**
 * AgentIdentityCard — compact read-only banner showing the active agent.
 * Clicking navigates to the agent detail page.
 *
 * Props:
 *   agent — portfolio.active_agent object { id, name, avatar_url, avatar_seed }
 *   label — optional override for the "via" label (default: "Primary agent")
 */
export default function AgentIdentityCard({ agent, label = 'Primary agent' }) {
  const navigate = useNavigate();

  if (!agent) return null;

  const { avatarSeed, paletteIndex } = parseSeed(agent.avatar_seed);
  const colors = PALETTES[paletteIndex] || PALETTES[0];

  return (
    <button
      onClick={() => navigate(`/agent/${agent.id}`)}
      className="w-full flex items-center gap-3 px-4 py-3 bg-slate-800/60 border border-slate-700 rounded-xl hover:border-cyan-700/60 hover:bg-slate-800 transition-colors text-left"
    >
      <AgentAvatar
        name={agent.name}
        seed={avatarSeed || agent.name}
        colors={colors}
        size={36}
      />
      <div className="min-w-0">
        <p className="text-xs text-slate-400">{label}</p>
        <p className="text-sm font-medium text-white truncate">{agent.name}</p>
      </div>
      <svg className="w-4 h-4 text-slate-500 ml-auto flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
      </svg>
    </button>
  );
}
